import $ from 'jquery';
import Glide from '@glidejs/glide';

export function LeadMagnet() {
  let waitForMCForm = setInterval(() => {
    if ($('#mc_embed_shell')) {
      clearInterval(waitForMCForm);

      // Landing Type 1
      setTimeout(() => {
        const $container = $('#mailchimp-form');

        const $button = $('#mc-embedded-subscribe');
        const $buttonContainer = $button.closest('.clear');

        const $checkbox = $('#agreement-checkbox');
        const $checkboxContainer = $checkbox.closest('.mkt-landing__hero__content__form__bottom');

        const $responses = $('#mce-responses');
        const $responsesContainer = $('.mkt-landing__hero__content__form__response');

        // Place Checkbox before the Button
        $buttonContainer.before($checkboxContainer);

        // Place Responses container after the Button
        $buttonContainer.after($responsesContainer);
        $responses.appendTo($responsesContainer);

        // Style inputs
        const $inputs = $('input.text, input.email');
        $inputs.addClass('base_input');

        // Hide technical inputs
        const $technicalInputs = $('input[name*="UTM"], input[name*="NOT_SET"], input[name*="LEAD"]');
        $technicalInputs.each(function() {
          $(this).closest('.mc-field-group').addClass('-hidden');
        });

        // Style the Button
        $button.removeClass('button').addClass('btn').addClass('btn-yellow');

        // Place text strings from Prismic
        const $title = $('#mc_embed_signup_scroll h2');
        $title.text($container.attr('data-form-title'));

        const $email = $('input.email');
        $email.attr('placeholder', $container.attr('data-email-placeholder'));

        if ($container.attr('data-button-text')) {
          $button.val($container.attr('data-button-text'));
        }

        // Make scripts coming from MC embed form code works
        const $scripts = $container.find('script');

        $scripts.each(function() {
          const $e = $(this);

          if ($e.attr('src')) {// External scripts
            const src = $e.attr('src');
            $e.remove();
            $container.append(`
              <script type="text/javascript" src="${src}" data-script-type="external"></script>
            `);
          } else {// Internal scripts
            const code = $e.html();
            $e.remove();

            let waitForJQuery = setInterval(() => {
              if (typeof window.jQuery !== 'undefined') {
                clearInterval(waitForJQuery);

                try {
                  // Execute script
                  const scriptFunction = new Function(code);
                  scriptFunction();
                } catch (error) {
                  console.error('Error executing MailChimp script:', error);
                }
              }
            }, 500);
          }
        });

        // Checkbox validation
        if ($('#agreement-checkbox').length > 0) {
          let $button = $('#mc-embedded-subscribe');
          let $checkbox = $('#agreement-checkbox');
          let $error = $('#agreement-error');

          $button.on('click', function(e) {
            if (!$checkbox.is(':checked')) {
              e.preventDefault();

              $error.show();
            } else {
              $error.hide();
            }
          });
        }

        // Replace MailChimp default success message
        if ($('#px-layout').hasClass('mkt-landing')) {
          function checkAndReplaceMessage() {
            const successDiv = $('#mce-success-response');
            const successText = $container.attr('data-success-message');

            if (successDiv && successDiv.text() !== '' && successDiv.text() !== successText) {
              successDiv.text(successText);
              successDiv.addClass('-visible');

              clearInterval(checkInterval);
            } else if (successDiv.text() === successText) {
              clearInterval(checkInterval);
            }
          }

          const checkInterval = setInterval(checkAndReplaceMessage, 500);
        }

        $('.mkt-landing__hero').addClass('-form-loaded');
      }, 500);

      // GlideJS (carousel in Latest Posts)
      setTimeout(() => {
        if ($('.glide').length > 0) {
          let per_view = 1.165;
          let gap = 24;

          var resizeEvent = new Event('resize');
          window.dispatchEvent(resizeEvent);

          new Glide('.glide', {
            type: 'slider',
            focusAt: 0,
            startAt: 0,
            perView: per_view,
            gap: gap
          }).mount();

          // Open video in the Pixellu Presents section
          var $slider = $('.blog__presents__slider .glide');

          $('.blog__presents__slider__item__image').each(function () {

            $(this).on('click.pxtrigger', function () {

              var $target = $(this).parent().find('.video-target');

              if (!$slider.hasClass('glide--draggable') && $target.attr('draggable') === 'true')
                $target.magnificPopup('open');

            });

          });
        }
      }, 1000);
    }
  }, 250);
}
